module.exports = "/_next/static/images/transaction-c6d2e9b6347e42d04e5b4e7775362f5c.svg";